import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
/** The standard white card (docs/architecture/37 § Cards): 1px border,
 * radius 12, a very soft shadow — never a bigger shadow at rest. */
export function Card({ className, ...rest }) {
    return (_jsx("div", { className: clsx('rounded-card border border-border bg-surface shadow-card', className), ...rest }));
}
//# sourceMappingURL=Card.js.map